import React from "react";
import "./IsLoadingApp.css";

const IsLoadingApp = () => {
  return (
    <div className="isLoadingApp">
      <span>E</span>
      <span>l</span>
      <span>e</span>
      <span>c</span>
      <span>t</span>
      <span>r</span>
      <span>o</span>
      <span>C</span>
      <span>a</span>
      <span>r</span>
      <span>t</span>
    </div>
  );
};

export default IsLoadingApp;
